<template>
  <el-checkbox-button v-bind="$attrs"> <slot /> </el-checkbox-button>
</template>

<script>
export default {
  name: 'RtCheckboxButton'
};
</script>



// WEBPACK FOOTER //
// rtCheckboxButton.vue?6671aec0